import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {

  title?: string;
  placeholder?: string;

  showContent: boolean;
  content?: string;

  showTextBox: boolean;
  no: string;
  yes: string;
  hideYesBtn: boolean;
  hideNoBtn: boolean;
  value?: string;

  showLabel: boolean;
  labelTitle: string;
  labelName: string;
}

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.html',
})
export class ConfirmationDialog {

  txtValue: String;
  result: DialogData = {
    // title: "Delete Confirmation", 
    showContent: true,
    // content: "Delete selected item will not be recoverd.", 
    yes: "Confirm",
    no: "Cancel",
    value:"",
    labelTitle: null,
    labelName: null,
    showTextBox: false,
    hideYesBtn: false,
    showLabel: false,
    hideNoBtn: false
  };

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.result = Object.assign(this.result, data);

    if (!this.result.title && !this.result.content) {
      this.result.content = "No Content";
    }

    if (this.result.showTextBox) {
      this.txtValue = data.value;
    }
  }

  save() {
    if (!this.txtValue) return;
    this.dialogRef.close(this.txtValue);
  }
  close() {
    this.dialogRef.close();
  }
}